import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { filterAllTruthyInTuple } from "core/rx-js";
import { BehaviorSubject, combineLatest, filter, map } from "rxjs";
import { OptionTemplateService } from "../../data-source-utils";
import mapItemDisplay from "../../form-rx-js/map-item-display";
import mapTemplateValue from "../../form-rx-js/map-template-value";

@Component({
  selector: 'ss-mat-option-template',
  templateUrl: './mat-option-template.component.html',
  styleUrls: ['./mat-option-template.component.css'],
  host: {
    class: 'padding-none display-block'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatOptionTemplateComponent implements OnInit {

  readonly matTemplateTypeObs = this._optionTemplateService.matTemplateTypeObs;
  readonly templateSubject = this._optionTemplateService.templateSubject;
  readonly displayExprSubject = this._optionTemplateService.displayExprSubject

  private readonly itemSubject = new BehaviorSubject<any>(null)
  @Input() get item() {
    return this.itemSubject.value
  }
  set item(value: any) {
    this.itemSubject.next(value)
  }

  readonly displayObs = combineLatest([
    this.itemSubject,
    this._optionTemplateService.displayExprSubject
  ])
    .pipe(
      filter(([item]) => Boolean(item)),
      mapItemDisplay()
    )

  readonly matOptionTemplateValuesObs = combineLatest([
    this.templateSubject,
    this.itemSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      mapTemplateValue()
    )


  readonly descriptionPartsObs = this.matOptionTemplateValuesObs.pipe(
    filter(Boolean),
    map(({ description }) => description),
    map((description) => description.split('\n'))
  )


  constructor(
    private _optionTemplateService: OptionTemplateService
  ) { }

  ngOnInit(): void {

  }


  getDisplayExpr() {

  }


}
